import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE, TOKEN, NAME } from '../../../_helpers/token';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  componentDidMount() {
    // axios.get(baseURL).then(res => { })

    if (TOKEN == null) {
      window.location.href = "/log_in";

    }
  }
  logout = () => {
    localStorage.removeItem('token');
  }
  render() {
    const { changeToLight, changeToDark } = this.props;



    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title="Layout" icon="layers">
            <button className="sidebar__link" type="button" onClick={changeToLight}>
              <p className="sidebar__link-title">Light Theme</p>
            </button>
            <button className="sidebar__link" type="button" onClick={changeToDark}>
              <p className="sidebar__link-title">Dark Theme</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">


          {ROLE !== '10' ?
            <>
              <SidebarLink
                title="PawaBox Search"
                route="/user_search"
                icon="user"
                onClick={this.hideSidebar}
              />
            </>
            : null
          }

          {ROLE === '6' || ROLE === '7' ?
            <>

              <SidebarLink
                title="PawaBox Stats"
                route="/players"
                icon="book"
                onClick={this.hideSidebar}
              />

              <SidebarLink title="Reconciliation" icon="briefcase" route="/reconciledeposits" onClick={this.hideSidebar} />

            </> :
            null
          }
          <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />

          <ul className="sidebar__block">
            <SidebarLink
              title="Logout"
              route="/log_in"
              onClick={this.logout}
              icon="exit"
            />
          </ul>

        </ul>
      </div >
    );
  }
}

export default SidebarContent;
